import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { SharedModule } from '../shared/shared.module';

import { ProductsComponent } from './products/products.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsComponent } from './terms/terms.component';
import { ReceptionComponent } from './reception/reception.component';
import { ContactUsComponent } from './contact-us/contact-us.component';



@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    SharedModule,
    TermsComponent,
    ReceptionComponent,
    ProductsComponent,
    PrivacyPolicyComponent,
    ContactUsComponent
  ],
  exports: [

    ProductsComponent,
    PrivacyPolicyComponent,
    TermsComponent,
    ReceptionComponent,

    ContactUsComponent
  ]
})
export class CoreModule { }
